import React from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
//Material imports
import classNames from "classnames";
import { useTheme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
//Limitless imports
import NavigationItem from "../navigation-item/NavigationItem";
import NavigationSubMenu from "../navigation-sub-menu/NavigationSubMenu";
import { useNavigation } from "../../../hooks/navigation/NavigationContext";
import { useExpertProfileContext } from "../../../../expert/hooks/expert-profile/ExpertProfileContext";
const drawerWidth = 250;
const useStyles = makeStyles(theme => {
  const drawerTransition = theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.easeOut,
    duration: theme.transitions.duration.enteringScreen
  });
  return {
    drawer: {
      flexShrink: 0,
      width: drawerWidth,
      transition: drawerTransition
    },
    drawerClosed: {
      flexShrink: 0,
      width: 0,
      transition: drawerTransition
    },
    drawerPaper: {
      position: "relative",
      whiteSpace: "nowrap",
      width: drawerWidth,
      boxShadow: "2px 0px 5px 0px rgba(0,0,0,0.3)",
      borderRight: "none",
      height: "calc(100vh - 64px)",
      zIndex: 1099
    },
    drawerPaperClose: {
      overflowX: "hidden"
    },
    navItemContainer: {
      padding: 0,
      backgroundColor: theme.background.paper,
      flex: 1
    }
  };
});
const LeftNavigation = ({
  navItems
}) => {
  const location = useLocation();
  const {
    isNavigationExpanded,
    navigate,
    toggleNavigationDrawer,
    isLargeScreen
  } = useNavigation();
  const {
    canUserAccess
  } = useExpertProfileContext();
  const theme = useTheme();
  const classes = useStyles(theme);
  const handleNavigation = (link, replace = false, hasChildren = false) => {
    if (!hasChildren && !isLargeScreen) {
      toggleNavigationDrawer();
    }
    navigate(link, replace);
  };
  return /*#__PURE__*/React.createElement(Drawer, {
    variant: `${isLargeScreen ? "persistent" : "temporary"}`,
    className: isNavigationExpanded ? classes.drawer : classes.drawerClosed,
    classes: {
      paper: classNames(classes.drawerPaper, !isNavigationExpanded && classes.drawerPaperClose)
    },
    open: isNavigationExpanded,
    transitionDuration: 195,
    anchor: "left",
    style: {
      top: isLargeScreen ? 0 : 64
    },
    onClose: toggleNavigationDrawer
  }, /*#__PURE__*/React.createElement(List, {
    className: classes.navItemContainer
  }, navItems.map((item, index) => {
    const selected = item.path === location.pathname ? true : false;
    const allowAccess = item.policy ? canUserAccess(item.policy) : true;
    if (item.text && allowAccess) {
      var _item$childRoutes$fil, _item$childRoutes;
      const childRoutes = (_item$childRoutes$fil = (_item$childRoutes = item.childRoutes) === null || _item$childRoutes === void 0 ? void 0 : _item$childRoutes.filter(route => !route.path.includes(":") && route.text)) !== null && _item$childRoutes$fil !== void 0 ? _item$childRoutes$fil : [];
      if (childRoutes.length !== 0) {
        return /*#__PURE__*/React.createElement(NavigationSubMenu, {
          key: index,
          id: index,
          navItem: item,
          onClickHandle: handleNavigation,
          canUserAccess: canUserAccess
        });
      } else {
        return /*#__PURE__*/React.createElement(NavigationItem, {
          key: index,
          id: index,
          text: item.text,
          icon: item.icon,
          link: item.path,
          selected: selected,
          onClickHandle: (link, replace) => handleNavigation(link, replace, false)
        });
      }
    }
    return null;
  })));
};
export default LeftNavigation;
LeftNavigation.propTypes = {
  navItems: PropTypes.array.isRequired
};